import {
  AppBar,
  Box,
  Drawer,
  List,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Theme,
  Toolbar,
  Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, useLocation } from 'react-router-dom';
import AccountPanel from '../../../components/Account/AccountPanel';
import IconLoader from '../../../components/IconLoader';
import Restricted from '../../../components/Permissions/Restricted';
import { useClientTheme } from '../../../helpers/hooks/useClientTheme';
import Routes from '../DashboardRoutes';

const drawerWidth = 200;

const useStyles = makeStyles((theme: Theme) => ({
  text: {
    color: '#707070',
  },
  selected: {
    borderRight: `5px solid ${theme.palette.primary.main} !important`,
    color: `${theme.palette.primary.main} !important`,
  },
  textSelected: {
    color: theme.palette.primary.main,
  },
  footer: {
    position: 'fixed',
    bottom: 0,
    width: '100%',
    height: 60,
    textAlign: 'center',
  },
}));

const NavigationBar: React.FC = () => {
  const classes = useStyles();
  const { t } = useTranslation(['navigation', 'common']);
  const { pathname } = useLocation();
  const activeRoute = (routeName: any) => {
    return pathname.includes(routeName);
  };
  const { isDefaultTheme, theme } = useClientTheme();

  return (
    <>
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          backgroundColor: '#fff',
          display: 'flex',
          flexDirection: 'row',
          //if bringing the SearchBar back, change below to space-between
          justifyContent: 'flex-end',
          width: `calc(100% - ${drawerWidth}px)`,
          ml: `${drawerWidth}px`,
        }}
      >
        {/*         <SearchBar />
         */}
        <Toolbar>
          <AccountPanel />
        </Toolbar>
      </AppBar>

      <Drawer
        variant="permanent"
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          [`& .MuiDrawer-paper`]: {
            width: drawerWidth,
            boxSizing: 'border-box',
            borderRight: '0px',
          },
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            width: drawerWidth - 10,
            ml: '10px',
            mt: '5px',
          }}
        >
          <img
            src={theme.images.mainLogo}
            alt="Client Logo"
            style={{ height: '100%', maxWidth: '100%', objectFit: 'contain' }}
          />
        </Box>
        <Box>
          <List>
            {Routes.map((prop, key) => {
              // @ts-ignore
              return (
                <Restricted
                  key={key}
                  to={prop.permissions}
                  fallback={undefined}
                >
                  <ListItemButton
                    classes={{ selected: classes.selected }}
                    sx={{ mt: 3 }}
                    key={key}
                    component={NavLink}
                    to={prop.path}
                    selected={activeRoute(prop.path)}
                  >
                    <ListItemIcon>
                      <IconLoader
                        name={prop.icon}
                        fill={
                          activeRoute(prop.path)
                            ? `${theme.palette.primary.main}`
                            : '#707070'
                        }
                      />
                    </ListItemIcon>
                    <ListItemText
                      classes={{ primary: classes.textSelected }}
                      primary={t(prop.sidebarName)}
                    />
                  </ListItemButton>
                </Restricted>
              );
            })}
          </List>
        </Box>
        <Box
          sx={{
            mt: `auto`,
            ml: 2,
            mb: 3,
          }}
        >
          {isDefaultTheme ? null : (
            <Typography
              sx={{
                mb: 1,
              }}
            >
              {t('common:poweredBy')}
            </Typography>
          )}

          <IconLoader name="WalkWithPathLogo" />
        </Box>
      </Drawer>
    </>
  );
};

export default NavigationBar;
